import React, { useEffect, useRef } from 'react';

interface VideoPreviewProps {
  videoUrl: string;
  subtitleUrl?: string;
}

export function VideoPreview({ videoUrl, subtitleUrl }: VideoPreviewProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && subtitleUrl) {
      const trackElement = videoRef.current.querySelector('track');
      if (trackElement) {
        trackElement.src = subtitleUrl;
      } else {
        const newTrackElement = document.createElement('track');
        newTrackElement.kind = 'subtitles';
        newTrackElement.src = subtitleUrl;
        newTrackElement.srclang = 'en';
        newTrackElement.default = true;
        videoRef.current.appendChild(newTrackElement);
      }
    }
  }, [subtitleUrl]);

  return (
      <video
          ref={videoRef}
          src={videoUrl}
          controls
          loop={false}
          disablePictureInPicture
          playsInline
          preload="auto"
          crossOrigin="anonymous"
      />
  );
}